import React from "react";
import { useNavigate, Link } from "react-router-dom";

export default function MainMenu() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch("https://spst.in/myapp/api/logout.php", {
                method: "POST",
            });

            // ❗ Remove authentication
            localStorage.removeItem("auth");

            // 🔴 Trigger logout in all tabs
            localStorage.setItem("logout", Date.now());

            // Redirect to login
            navigate("/");

        } catch (error) {
            console.error("Logout failed:", error);
        }
    };


    return (
        <div>

            <div class="row" style={{ background: 'orange_' }}>
                <div className="container_ containeritems" >
                    <div className="boxes">
                        <Link to="../Dashboard" className="menuitems" ><i class="fa fa-tachometer" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Deshboard</span></Link>
                    </div>
                    <div className="boxes">
                        <Link to="../Newprofile" className="menuitems" ><i class="fa fa-user" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Manage Profile</span></Link>
                    </div>
                    <div className="boxes">
                        <Link to="../Searchprofile" className="menuitems" ><i class="fa fa-users" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Search Profile</span></Link>
                    </div>
                    {/* <div className="boxes">
                        <Link to="../DarsanTime" className="menuitems" ><i class="fa fa-clock-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Darsan Time</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Notices" className="menuitems"><i class="fa fa-cloud" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <span className="menuitems">Updates</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Updates" className="menuitems"><i class="fa fa-cloud" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Updates</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Photo" className="menuitems"><i class="fa fa-image" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Gallery</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Register" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-home" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Register</p></Link>
                    </div> */}
                    <div className="boxes">
                        <span className="menuitems">
                            <i class="fa fa-power-off" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span
                                onClick={handleLogout}
                                className="menuitems">
                                Logout
                            </span>
                        </span>

                    </div>
                </div>
            </div>
        </div>
    );
}
